import { graphql } from "relay-runtime"

export const chBetterDocUsageForConsultationQuery = graphql`
  query useChBetterDocUsageForConsultationQuery(
    $patientId: ID!
    $diagnosisCode: String
    $effectivePointOfCare: PointOfCareType!
    $specialtyId: ID
  ) {
    betterDocUsageForConsultation: ch_betterDocUsageForConsultation(
      patientId: $patientId
      diagnosisCode: $diagnosisCode
      effectivePointOfCare: $effectivePointOfCare
      specialtyId: $specialtyId
    )
    missingConsultationDetailsThatCanChangeBetterDocUsage: ch_missingConsultationDetailsThatCanChangeBetterDocUsage(
      patientId: $patientId
      diagnosisCode: $diagnosisCode
      effectivePointOfCare: $effectivePointOfCare
      specialtyId: $specialtyId
    )
  }
`
